import { render, staticRenderFns } from "./ShopCard.vue?vue&type=template&id=03042d34&scoped=true"
import script from "./ShopCard.vue?vue&type=script&lang=ts"
export * from "./ShopCard.vue?vue&type=script&lang=ts"
import style0 from "./ShopCard.vue?vue&type=style&index=0&id=03042d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03042d34",
  null
  
)

export default component.exports